
import React from "react";
import { Button } from "@/components/ui/button";
import { Image as ImageIcon } from "lucide-react";
import { toast } from "sonner";

interface ImageUploadButtonProps {
  isLoading: boolean;
  isRecording: boolean;
  isProcessingAudio: boolean;
  onImageChange: (file: File | null) => void;
}

export const ImageUploadButton: React.FC<ImageUploadButtonProps> = ({
  isLoading,
  isRecording,
  isProcessingAudio,
  onImageChange
}) => {
  const handleImageInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;
    
    if (!file.type.startsWith('image/')) {
      toast.error("Format non supporté", {
        description: "Veuillez sélectionner un fichier image valide."
      });
      return;
    }
    
    if (file.size > 5 * 1024 * 1024) {
      toast.error("Image trop volumineuse", {
        description: "L'image ne doit pas dépasser 5MB."
      });
      return;
    }
    
    onImageChange(file);
    toast.success("Image sélectionnée", {
      description: "L'image est prête pour analyse."
    });
  };

  return (
    <>
      <input 
        type="file"
        id="image-upload"
        className="hidden"
        accept="image/jpeg,image/png,image/webp"
        onChange={handleImageInput}
      />
      
      <Button
        type="button"
        variant="ghost"
        size="sm"
        className="absolute right-2 bottom-2 h-7 w-7 p-0 rounded-full text-blue-600 hover:text-blue-800"
        onClick={() => document.getElementById('image-upload')?.click()}
        disabled={isLoading || isRecording || isProcessingAudio}
        title="Ajouter une image médicale"
      >
        <ImageIcon className="h-4 w-4" />
        <span className="sr-only">Ajouter une image</span>
      </Button>
    </>
  );
};
